import React from "react";
import SidebarNav from "./components/SidebarNav";
import Intro from "./components/Intro";
import About from "./components/About";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Credits from "./components/Credits";
import "./App.css";
import "./styles/Global.css";
import "rsuite/dist/styles/rsuite-default.css";
import MainCertificate from "./components/MainCertificate";

function App() {
  return (
    <div className="App">
      <div id="content">
        <Intro></Intro>
        <About></About>
        <Experience ></Experience>
        <MainCertificate/>
        <Projects></Projects>
        <Credits></Credits>
      </div>
      <SidebarNav />
    </div>
  );
}

export default App;
